module.exports = __webpack_public_path__ + "static/chart-dosing1-10ba98a5a4fd5683a8d368f26ce83a8a.png";